import ajax from "./ajax";
/**
 * 获取空状态缓存数据
 * @param {*string} userId 用户唯一标识
 * @param {*string} appcode 应用编码
 * @param {*string} pagecode 页面编码
 * @param {*string} historytype "1/2",(1-公共查询条件,2-交易类型)
 * @param {*string} areacode 所关联的查询区区域编码
 * @param {*string} recordtime 客户端时间
 * @param {*string} querycondition 查询条件大json
 */
export function setUserQueryHistory(data, callback){
    ajax({
        url: '/nccloud/platform/templet/addUserQueryHistory.do',
        async: true,
        loading: false,
        data: data,
        success: res => {
            console.log(res);
            callback && callback();
            return res;
        },
    });
}